import { render, staticRenderFns } from "./FilesExplorerModuleLayout.vue?vue&type=template&id=1136aa72"
import script from "./FilesExplorerModuleLayout.vue?vue&type=script&lang=js"
export * from "./FilesExplorerModuleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports